
import React from 'react';

import AttributeDownloadContent from './AttributeDownloadContent';
import AttributeExecuteCommand from './AttributeExecuteCommand';
import AttributeImages from './AttributeImages';
import AttributeLabel from './AttributeLabel';
import AttributeLink from './AttributeLink';
import AttributeSeparator from './AttributeSeparator';
import AttributeTextField from './AttributeTextField';

import { Log } from '../../../core';
const log = Log.getLogger('MultiSceneForApp.app.Attribute');

const Attribute = ({
    appConfig,
    definition,
    infoDefinition,
    values,
    onCloseDialog,
    onLightboxOpenChange
}) => {

    const type = definition.type || 'Label';
    switch (type) {
        case 'Images':
            return (
                <AttributeImages
                    appConfig={appConfig}
                    definition={definition}
                    infoDefinition={infoDefinition}
                    values={values}
                    onLightboxOpenChange={onLightboxOpenChange}
                />
            );
        case 'Label':
            return (
                <AttributeLabel
                    appConfig={appConfig}
                    definition={definition}
                    infoDefinition={infoDefinition}
                    values={values}
                />
            );
        case 'Link':
            return (
                <AttributeLink
                    appConfig={appConfig}
                    definition={definition}
                    infoDefinition={infoDefinition}
                    values={values}
                />
            );
        case 'Separator':
            return (
                <AttributeSeparator
                    appConfig={appConfig}
                    definition={definition}
                    infoDefinition={infoDefinition}
                    values={values}
                />
            );
        case 'TextField':
            return (
                <AttributeTextField
                    appConfig={appConfig}
                    definition={definition}
                    infoDefinition={infoDefinition}
                    values={values}
                />
            );
        case 'DownloadContent':
            return (
                <AttributeDownloadContent
                    appConfig={appConfig}
                    definition={definition}
                    infoDefinition={infoDefinition}
                    values={values}
                />
            );
        case 'ExecuteCommand':
            return (
                <AttributeExecuteCommand
                    appConfig={appConfig}
                    definition={definition}
                    infoDefinition={infoDefinition}
                    values={values}
                    onCloseDialog={onCloseDialog}
                />
            );
        default:
            log.warn(`unknown attribute type: ${type}`);
            return null;
    }
}

export default Attribute;
